import { cn } from "@/lib/utils";

export interface JumpNavItem {
  id: string;
  label: string;
}

interface JumpNavProps {
  items: JumpNavItem[];
  className?: string;
}

const JumpNav = ({ items, className }: JumpNavProps) => {
  return (
    <nav
      aria-label="In-page sections"
      className={cn(
        "sticky top-16 z-30 w-full bg-background/95 backdrop-blur border-b border-border",
        className
      )}
    >
      <div className="container mx-auto px-4 flex justify-center">
        <ul className="flex gap-2 md:gap-3 overflow-x-auto snap-x snap-mandatory py-2 scrollbar-hide justify-center">
          {items.map((item) => (
            <li key={item.id} className="snap-start shrink-0">
              <a
                href={`#${item.id}`}
                className="inline-block whitespace-nowrap rounded-full border border-border bg-card px-4 py-1.5 text-sm font-medium text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default JumpNav;